module.exports = __webpack_public_path__ + "img/icon_lastpage.9f557ca5.png";